import Vue from 'vue';
import Layout from "@/book/Layout.vue";
import Extract from "@/book/Extract.vue";
import CodeSample from "@/book/CodeSample.vue";
import Confetti from "@/book/Confetti.vue";
import DownloadExample from "@/book/DownloadExample.vue";

// Syntax highlighting
import 'prismjs'
import 'prismjs/themes/prism.css'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-yaml'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-diff'

// Bootstrap
import '../init'
import '../assets/book.css'

Vue.component('layout', Layout);
Vue.component('extract', Extract);
Vue.component('sample', CodeSample);
Vue.component('confetti', Confetti);
Vue.component('download-example', DownloadExample);
